<template>
  <vx-tooltip text="Скачать историю переписки">
    <button
      class="messenger-buttons__item"
      @click.prevent="handleClickDownload"
    >
      <feather-icon
        icon="DownloadIcon"
      />
    </button>
  </vx-tooltip>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

import Client from '@/api/http/models/Client'

import downloadFile from '@/mixins/downloadFile'

export default {
  mixins: [downloadFile],

  computed: {
    ...mapGetters(['authUserCompany', 'currentClient'])
  },

  methods: {
    async handleClickDownload () {
      const response = await Client.exportHistory(this.authUserCompany.slug, this.currentClient.client_id)

      if (response) {
        const timezone = this.authUserCompany.timezone || 0
        const timestamp = moment.utc(new Date()).utcOffset(timezone).valueOf()
        const filename = `export_client_${this.currentClient.client_id}_${timestamp}.html`
        this.downloadFile(response, filename)
      }
    }
  }
}
</script>
